module.exports = __webpack_public_path__ + "static/media/PHOTO_CHRISTIAN.b2ee082c.png";